import React from 'react';
import RemoteImageReferralDetailNavbar from '../RemoteImageReferralDetailNavbar';
import RemoteImageReferralDetailInfo from '../RemoteImageReferralDetailInfo';

const RemoteImageReferralDetailWrap = (props) => {
  const { detailPageType, onSubmit, remoteImageReferralDetail, setData, copyUrl } = props;

  return (
    <div className="remote-image-detail-wrap">
      {/* 하단 네브바 */}
      <RemoteImageReferralDetailNavbar
        detailPageType={detailPageType}
        remoteImageReferralDetail={remoteImageReferralDetail}
        onSubmit={onSubmit}
      />

      {/* 원격 이미지 정보 */}
      <RemoteImageReferralDetailInfo
        detailPageType={detailPageType}
        remoteImageReferralDetail={remoteImageReferralDetail}
        setData={setData}
        copyUrl={copyUrl}
      />
    </div>
  );
};

export default RemoteImageReferralDetailWrap;
